import { store } from 'redux/store';

import { Partner, Society } from 'types';

import { getDocument } from 'modules/documents/redux/documentActions';
import { generateDocumentWithTags } from 'utils/generateDocumentWithTags';

type GenerateIrpfCertificateProps = {
  partner: Partner | null;
  society: Society;
};

type LanguageMap = {
  [key: string]: string | undefined;
};

const getDocumentName = (partner: Partner | null): string => {
  const defaultName = `Certificado IRPF - ${partner?.partnerNumber}.pdf`;

  return defaultName;
};

const getIrpfCertificateDocumentId = (
  society: Society,
  partner: Partner | null
) => {
  const partnerLanguage = partner?.language || 'es';

  const languageMap: LanguageMap = {
    es: society?.templates?.irpfCertificateES,
    cat: society?.templates?.irpfCertificateES, // This has no catalan version
  };

  return languageMap[partnerLanguage];
};

const getIrpfCertificateFooterDocumentId = (society: Society) =>
  society?.templates?.irpfCertificateFooter;

const getPartnerId = (partner: Partner | null) => partner?.['_id'];

const getSocietyId = (society: Society) => society?._id;

const getDocumentIds = (society: Society, partner: Partner | null) => {
  const irpfCertificateDocumentId = getIrpfCertificateDocumentId(
    society,
    partner
  );

  const irpfCertificateFooterDocumentId =
    getIrpfCertificateFooterDocumentId(society);

  return {
    irpfCertificateDocumentId,
    irpfCertificateFooterDocumentId,
  };
};

export const generateIrpfCertificate = async ({
  partner,
  society,
}: GenerateIrpfCertificateProps) => {
  const documentName = getDocumentName(partner);

  const { irpfCertificateDocumentId, irpfCertificateFooterDocumentId } =
    getDocumentIds(society, partner);

  const irpfCertificateDocument = await store.dispatch(
    getDocument(irpfCertificateDocumentId)
  );

  const irpfCertificateFooterDocument = await store.dispatch(
    getDocument(irpfCertificateFooterDocumentId)
  );

  const partnerId = getPartnerId(partner);
  const societyId = getSocietyId(society);

  const sources = {
    partner: partnerId,
    society: societyId,
  };

  if (irpfCertificateDocumentId && partnerId) {
    await generateDocumentWithTags({
      documentId: irpfCertificateDocumentId,
      documentName,
      sources,
      language: 'es',
      footerHtml: irpfCertificateFooterDocument?.editorModel || '',
      pageMargin: irpfCertificateDocument?.pdfExport?.margin,
      showOnlyValues: false,
    });
  }
};
